import React, { useEffect, useMemo, useState } from "react";
import { Breadcrumb, message, Pagination, Skeleton, Table, Tabs, TabsProps } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useCallback } from "react";
// import axiosConfig from "../../../util/axiosConfig";
import { Link, useSearchParams } from "react-router-dom";
import { OrdersType } from "../../../shared/interfaces/requests.interface";
import { getAllRequest } from "../../../services/requestService";
import placeholder from "../../../util/placeholder";
import dayjs from "dayjs";
import { useCurrency } from "../../../hooks/useCurrency";
import { ChevronLeft } from "lucide-react";
import { REQUEST_STATUS } from "../../../util/constants";


const Requests: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [page] = React.useState(1);
  const [ searchParams ] = useSearchParams();
  const status = searchParams.get('status') || sessionStorage.getItem('active-request-tab');
  // const [paginationSize] = useState(10);
  const [requests, setRequests] = useState<OrdersType[]>([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 10
  })
  // const [initiatedOrders, setInitiatedOrders] = useState<InitiatedOrder[]>([]);
  // TODO: Ask Martins to check the data return when paymentStatus is set to false
  const [requestStatus, setRequestStatus] = useState(status || 'PENDING');
  const {formatCurrency} = useCurrency();

  const columns: ColumnsType<OrdersType> = [
    {
      title: "Rental ID",
      dataIndex: "invoiceId",
      key: "invoiceId",
      render: (_, record, index) => (
        <Link to={"/admin/requests/" + record.id}>{record.invoiceId}</Link>
      ),
    },
    {
      title: "Payment Reference",
      dataIndex: "paymentReference",
      key: "paymentReference",
      render: (_, record) => (<span>{record?.paymentReference}</span>),
    },
    {
      title: "Godump Charge",
      dataIndex: "gdCharge",
      key: "gdCharge",
      render: (_, record) => (
        <div className="text-primary">
          {formatCurrency(Number(record.gdCharge || 0))}
        </div>
      ),
    },
    {
      title: "Value",
      dataIndex: "amountCharged",
      key: "amountCharged",
      render: (_, record) => (
        <div className="text-secondary">
          {formatCurrency(Number(record.amountCharged || record.totalPrice))}
        </div>
      ),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (_, record) => (
        <div>
          {dayjs(record.createdAt).format('DD/MM/YYYY')}
        </div>
      ),
    },
    {
      title: "Pick Up",
      dataIndex: "pickupZone",
      key: "pickupZone",
      render: (_, record) => <div className="max-w-36 text-nowrap text-ellipsis overflow-hidden">{record?.pickupAddress}</div>,
    },
    {
      title: "Destination",
      dataIndex: "dropoffZone",
      key: "dropoffZone",
      render: (_, record) => <div className="max-w-36 text-nowrap text-ellipsis overflow-hidden">{record?.dropoffAddress}</div>,
    },
    {
      title: "Material",
      dataIndex: "material",
      key: "material",
      render: (_, record, index) => (<div className="relative w-16 h-8">
        <img
          src={placeholder}
          alt="Material"
          className="absolute z-0 top-0 left-0 w-full h-full object-cover opacity-70 rounded"
        />
        <strong className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-semibold text-sm text-white z-20 border border-secondary capitalize">{record.material}</strong>
      </div>),
    },
    {
      title: "Renter",
      dataIndex: "renterName",
      key: "renterName",
      render: (_, record, index) => (
        <Link to={"#"} className="max-w-36 text-nowrap text-ellipsis overflow-hidden block">{record.renterName}</Link>
      ),
    }
  ];

  const activeColumns: ColumnsType<OrdersType> = columns.map(col => {
    if (col.title === 'Value') {
      return {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (_, record) => (
          <div className="text-primary font-semibold">
            {record.status}
          </div>
        ),
      }
    }
    return col;
  })

  // const initiatedColumns: ColumnsType<InitiatedOrder> = [
  //   {
  //     title: "#",
  //     dataIndex: "id",
  //     render: (_, record, index) => (page - 1) * paginationSize + index + 1,
  //   },
  //   {
  //     title: "Date Created",
  //     dataIndex: "createdAt",
  //     key: "createdAt",
  //     render: (_, record) => (
  //       <div>
  //         {new Date(record.createdAt).toLocaleDateString("en-GB", {
  //           day: "2-digit",
  //           month: "2-digit",
  //           year: "numeric",
  //         })}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Partner",
  //     dataIndex: "partnerName",
  //     key: "partnerName",
  //     render: (_, record, index) => (
  //       <Link to={`/admin/partners/${record.partnerId}?fromRequest=true`}>{record.partnerId}</Link>
  //     ),
  //   },
  //   {
  //     title: "No Of Trips",
  //     dataIndex: "noOfTrips",
  //     key: "noOfTrips",
  //   },
  //   {
  //     title: "Pickup Point",
  //     dataIndex: "pickUpPoint",
  //     key: "pickUpPoint",
  //   },
  //   {
  //     title: "Delivery Point",
  //     dataIndex: "deliveryPoint",
  //     key: "deliveryPoint",
  //   },
  //   {
  //     title: "Price",
  //     dataIndex: "price",
  //     key: "price",
  //     render: (_, record) => (
  //       <div>
  //         {Number(record.price).toLocaleString("en-NG", {
  //           style: "currency",
  //           currency: "NGN",
  //         })}
  //       </div>
  //     ),
  //   },
  // ];

  const items: TabsProps["items"] = [
    {
      key: REQUEST_STATUS.PENDING,
      label: "Pending",
      children: isLoading ? <Skeleton active paragraph={{ rows: 8 }} /> : <Table columns={columns} dataSource={requests} rowKey="id" pagination={false} />,
    },
    {
      key: REQUEST_STATUS.ASSIGNED,
      label: "Assigned",
      children: isLoading ? <Skeleton active paragraph={{ rows: 8 }} /> : <Table columns={columns} dataSource={requests} rowKey="id" pagination={false} />,
    },
    {
      key: REQUEST_STATUS.REJECTED,
      label: "Rejected",
      children: isLoading ? <Skeleton active paragraph={{ rows: 8 }} /> : <Table columns={columns} dataSource={requests} rowKey="id" pagination={false} />,
    },
    {
      key: REQUEST_STATUS.ACTIVE,
      label: "Active",
      children: isLoading ? <Skeleton active paragraph={{ rows: 8 }} /> : <Table columns={activeColumns} dataSource={requests} rowKey="id" pagination={false} />,
    },
    {
      key: REQUEST_STATUS.COMPLETED,
      label: "Recently Completed",
      children: isLoading ? <Skeleton active paragraph={{ rows: 8 }} /> : <Table columns={columns} dataSource={requests} rowKey="id" pagination={false} />,
    },
    // {
    //   key: "2",
    //   label: `Partner Initiated Request`,
    //   children: <Table columns={initiatedColumns} dataSource={initiatedOrders} rowKey="id" />,
    // },
  ];

  const getOrders = useCallback(async () => {
    setIsLoading(true);

    const res = await getAllRequest(requestStatus);
    setRequests(res.requests ?? []);
    setPagination(res.pagination ?? pagination);

    setIsLoading(false);
  }, [requestStatus, setIsLoading, setRequests]);

  useEffect(() => {
    getOrders();
    // getInitiatedOrder();
  }, [pagination.currentPage, requestStatus]);

  return (
    <div className="bg-white">
      <div className="flex items-center justify-between">
        <div className="my-8">
          <h1 className="text-blue-600 text-lg mb-0 flex items-center gap-2 font-bold">
            <ChevronLeft className="text-lg" onClick={() => window.history.back()} />
            <span className="font-bold">Rental Requests</span>
          </h1>
        </div>
      </div>
      <div className="site-layout-background w-full overflow-auto bg-white p-4">
        <Tabs
          defaultActiveKey={status || REQUEST_STATUS.PENDING}
          items={items}
          onChange={(key) => {
          sessionStorage.setItem('active-request-tab', key);
          setRequestStatus(key)
          }}
        />
        <br />
        {pagination.totalItems > 1 && (<Pagination align="end" defaultCurrent={1} total={pagination.totalItems} onChange={(page) => setPagination((prev) => ({...prev, currentPage: page}))} />)}
      </div>
    </div>
  );
};

export default Requests;
